import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Table, TableBody, TableCell, TableRow } from "@mui/material";
type Props = {
  tanggal: string;
  obats: any;
  title: string;
};

const AccordionObat = ({ tanggal, obats, title }: Props) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Accordion
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
      //   variant="outlined"
      elevation={0}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ width: "33%", flexShrink: 0 }}>
          <Typography component="span" sx={{ display: "block" }}>
            {tanggal}
          </Typography>
          <Typography
            component="span"
            sx={{ color: "text.secondary", display: "block" }}
          >
            {title || "-"}
          </Typography>
        </Box>
        <Typography
          component="span"
          sx={{ color: "text.secondary", alignSelf: "center" }}
        >
          {obats[0]?.nama}
          {obats.length - 1 > 0 && ` +${obats.length - 1} lainnya`}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            maxHeight: "200px",
            overflowY: "scroll",
          }}
        >
          <Table>
            <TableBody>
              {obats.map((item: any) => (
                <TableRow
                  // key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {item.nama}
                  </TableCell>
                  <TableCell align="right">{item.qty}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionObat;
